import React from 'react';
import { Box, FormLabel } from '@mui/material';

export default function WrapperFormLabel({ children }: { children: React.ReactNode }) {
    return (
        <FormLabel sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>{children}</Box>
        </FormLabel>
    );
}
